<template>
  <div className="animated">
    <b-card>
      <b-card-header>
        <i class="icon-menu mr-1"></i>Users
      </b-card-header>
      <b-card-body>
        <div class="search-box">
          <b-form-group class="search-condition">
            <b-form-select v-model="searchOption.disabled"
              :plain="true"
              :options="disabledOptions">
            </b-form-select>
          </b-form-group>
          <b-form-group class="search-condition">
            <b-form-select v-model="searchOption.emailVerified"
              :plain="true"
              :options="emailVerifiedOptions">
            </b-form-select>
          </b-form-group>
          <b-form-group class="search-condition">
            <b-form-select v-model="searchOption.hasDevice"
              :plain="true"
              :options="hasDeviceOptions">
            </b-form-select>
          </b-form-group>
          <b-form-group class="search-condition">
            <range-date-picker :initRange="initRange" @selected="onDateSelected" class="date-picker" />
          </b-form-group>
          <b-button type="submit" variant="primary" class="btn-pill" @click.stop="search">
            <i class="fa fa-search"></i>&nbsp;Search
          </b-button>
        </div>
        <Users :key="componentKey" :searchOption="searchOption"/>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
  import { ClientTable, Event } from 'vue-tables-2'
  import RangeDatePicker from '../../components/RangeDatePicker'
  import { utils } from '../../mixins/utils'
  import Users from '../users/Users'

  export default {
    name: 'UserList',
    mixins: [utils],
    components: {
      ClientTable,
      RangeDatePicker,
      Event,
      Users
    },
    data: function() {
      return {
        componentKey: 0,
        searchOption: {
          disabled: false,
          emailVerified: true,
          hasDevice: null,
          createdFrom: null,
          createdTo: null
        },
        disabledOptions: [
          { value: null, text: 'All'},
          { value: false, text: 'Active'},
          { value: true, text: 'Inactive'},
        ],
        emailVerifiedOptions: [
          { value: null, text: 'All'},
          { value: true, text: 'Verfied'},
          { value: false, text: 'Unverified'},
        ],
        hasDeviceOptions: [
          { value: null, text: 'All'},
          { value: false, text: 'No device'},
        ],
      }
    },
    computed: {
      initRange() {
        return {
          start: this.$moment(this.searchOption.createdFrom, 'YYYY-MM-DD').startOf('day').toDate(),
          end: this.$moment(this.searchOption.createdTo, 'YYYY-MM-DD').endOf('day').toDate(),
        }
      }
    },
    created() {
      this.initSearchOptionFromQuery()
      this.updateUrl()
    },
    methods: {
      onDateSelected(selected) {
        console.info('from:' + selected.start + ' to:' + selected.end)
        this.searchOption.createdFrom = selected.start
        this.searchOption.createdTo = selected.end
      },
      initSearchOptionFromQuery() {
        if (this.$route.query.hasOwnProperty('disabled')) this.searchOption.disabled = this.toBoolOrNull(this.$route.query.disabled)
        if (this.$route.query.hasOwnProperty('emailVerified')) this.searchOption.emailVerified = this.toBoolOrNull(this.$route.query.emailVerified)
        if (this.$route.query.hasOwnProperty('hasDevice')) this.searchOption.hasDevice = this.toBoolOrNull(this.$route.query.hasDevice)
        Object.assign(this.searchOption, this.$route.query)
        if (this.isValidQueryCreatedDate(this.searchOption)) return
        this.searchOption.createdFrom = this.$moment(this.$store.getters.lastDateRange.start).format('YYYY-MM-DD')
        this.searchOption.createdTo = this.$moment(this.$store.getters.lastDateRange.end).format('YYYY-MM-DD')
      },
      updateUrl() {
        const query = JSON.parse(JSON.stringify(this.$route.query))
        if (this._.isEqual(query, this.searchOption)) return

        console.log('replace query', query, this.searchOption)
        this.$router.replace({ path: this.$route.path, query: this.searchOption })
        console.log('replace route query', this.$route.query)
      },
      search() {
        console.info('search() ', this.searchOption)
        this.updateUrl()
        this.componentKey += 1
      }
    }
  };
</script>
